import {
	createActionsHook,
	createStore,
	type BoundActions,
	type HookActionsFunction,
	type Store,
	type StoreActionApi,
} from 'react-sweet-state';

import { type ConversationAction } from '@atlassian/rovo-conversation-actions/types';

export type DailyBriefUnread = {
	conversationId: string;
	name: string | null;
	/** ISO timestamp of when the daily brief agent message completed (last_message_timestamp). */
	completedAt: string | null;
} | null;

export type AISmartButtonState = {
	buttonClickedTimestamp?: number;
	dailyBriefUnread: DailyBriefUnread;
	nudges: ConversationAction[];
};

export const initialState: AISmartButtonState = {
	nudges: [],
	dailyBriefUnread: null,
};

export const actions = {
	setNudges:
		(nudges: ConversationAction[]) =>
		({ setState }: StoreActionApi<AISmartButtonState>): void => {
			setState({ nudges });
		},
	setButtonClickedTimestamp:
		(buttonClickedTimestamp: number) =>
		({ setState }: StoreActionApi<AISmartButtonState>): void => {
			setState({ buttonClickedTimestamp });
		},
	setDailyBriefUnread:
		(dailyBriefUnread: DailyBriefUnread) =>
		({ setState }: StoreActionApi<AISmartButtonState>): void => {
			setState({ dailyBriefUnread });
		},
};

export const AISmartButtonStore: Store<
	AISmartButtonState,
	{
		setButtonClickedTimestamp: (
			buttonClickedTimestamp: number,
		) => ({ setState }: StoreActionApi<AISmartButtonState>) => void;
		setDailyBriefUnread: (
			dailyBriefUnread: DailyBriefUnread,
		) => ({ setState }: StoreActionApi<AISmartButtonState>) => void;
		setNudges: (
			nudges: ConversationAction[],
		) => ({ setState }: StoreActionApi<AISmartButtonState>) => void;
	}
> = createStore({
	initialState,
	actions,
	name: 'AISmartButtonStore',
});

export const useAISmartButtonActions: HookActionsFunction<
	BoundActions<
		AISmartButtonState,
		{
			setButtonClickedTimestamp: (
				buttonClickedTimestamp: number,
			) => ({ setState }: StoreActionApi<AISmartButtonState>) => void;
			setDailyBriefUnread: (
				dailyBriefUnread: DailyBriefUnread,
			) => ({ setState }: StoreActionApi<AISmartButtonState>) => void;
			setNudges: (
				nudges: ConversationAction[],
			) => ({ setState }: StoreActionApi<AISmartButtonState>) => void;
		}
	>
> = createActionsHook(AISmartButtonStore);
export type AISmartButtonActions = ReturnType<typeof useAISmartButtonActions>;
